import { Component, Input } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';

@Component({
  selector: 'app-search-result-card',
  templateUrl: './search-result-card.component.html',
  styleUrls: [ './search-result-card.component.scss' ],
  standalone: true
})
export class SearchResultCardComponent {
  @Input() result: EverythingSearchResult;
}
